import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { AlertCircle } from 'lucide-react';

/**
 * Composant d'erreur réutilisable pour les champs de formulaire
 * @param {Object} props - Propriétés du composant
 * @param {string} props.error - Message d'erreur à afficher
 * @param {string} props.fieldName - Nom du champ pour l'accessibilité
 * @param {boolean} props.show - Contrôle l'affichage de l'erreur
 */
const FieldError = ({ error, fieldName, show = true }) => {
  return (
    <AnimatePresence>
      {error && show && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.2 }}
          className="flex items-center gap-2 text-error text-sm mt-1"
          id={`${fieldName}-error`}
          role="alert"
          aria-live="polite"
        >
          <AlertCircle size={16} className="flex-shrink-0" />
          <span>{error}</span>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default FieldError;